import { formatDateBR } from "../../shared/dates.ts";

interface Row { id?: string | null; description: string | null; starts_on: string | null; ends_on: string | null; weight?: number | null }

/** Read-only actions/tasks: a table on desktop, stacked cards on phones (UX-36). */
export function ReadonlyRows({ rows, kind = "action" }: { rows: Row[]; kind?: "action" | "task" }) {
  const withWeight = kind === "action";
  const head = kind === "action" ? "Ação / entrega" : "Tarefa";
  if (rows.length === 0) return <p className="py-3 text-sm text-muted">Nenhuma {kind === "action" ? "ação" : "tarefa"} cadastrada.</p>;
  return (
    <>
      <table className="hidden w-full text-sm md:table">
        <thead>
          <tr className="bg-paper text-left">
            <th className="eyebrow w-8 p-2">#</th><th className="eyebrow p-2">{head}</th><th className="eyebrow w-28 p-2">Início</th><th className="eyebrow w-28 p-2">Término</th>
            {withWeight && <th className="eyebrow w-16 p-2 text-right">Peso</th>}
          </tr>
        </thead>
        <tbody>
          {rows.map((a, i) => (
            <tr key={a.id ?? i} className="border-b border-line align-top transition-colors hover:bg-paper/70">
              <td className="num p-2 text-[13px] text-muted">{i + 1}</td>
              <td className="p-2">{a.description ?? <span className="text-muted italic">a definir</span>}</td>
              <td className="num p-2 text-[13px] whitespace-nowrap">{formatDateBR(a.starts_on) || "—"}</td>
              <td className="num p-2 text-[13px] whitespace-nowrap">{formatDateBR(a.ends_on) || "—"}</td>
              {withWeight && <td className="num p-2 text-right text-[13px]">{a.weight ?? "—"}</td>}
            </tr>
          ))}
        </tbody>
      </table>
      <ol className="space-y-2 md:hidden">
        {rows.map((a, i) => (
          <li key={a.id ?? i} className="rounded-ctl border border-line bg-surface p-3 text-sm shadow-e1">
            <p className="font-medium"><span className="mr-1 text-muted">{i + 1}.</span>{a.description ?? <span className="text-muted italic">a definir</span>}</p>
            <dl className="mt-1.5 grid grid-cols-3 gap-2 text-xs">
              <div><dt className="text-muted">Início</dt><dd>{formatDateBR(a.starts_on) || "—"}</dd></div>
              <div><dt className="text-muted">Término</dt><dd>{formatDateBR(a.ends_on) || "—"}</dd></div>
              {withWeight && <div><dt className="text-muted">Peso</dt><dd>{a.weight ?? "—"}</dd></div>}
            </dl>
          </li>
        ))}
      </ol>
    </>
  );
}
